import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { FormTriggerBase } from '../../form-trigger-base';
import { FormIconPipe } from '../../../pipes/form-icon.pipe';
import { TuiButton, TuiHint } from '@taiga-ui/core';

export type FormGridTriggerPlacement = 'section' | 'question';

@Component({
  selector: 'pxc-form-grid-trigger',
  templateUrl: './form-grid-trigger.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class: 'flex flex-col gap-2',
  },
  imports: [TranslocoDirective, TuiButton, TuiHint, FormIconPipe],
})
export class FormGridTriggerComponent extends FormTriggerBase {
  readonly placement = input.required<FormGridTriggerPlacement>();
}
